import React, { useCallback, useEffect, useState } from 'react';

import confirm from 'components/confirm';
import { deleteShowcaseContact, fetchShowcaseContacts } from './api';
import ShowcaseContactModal from './modal';
import { Button, Card } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { showSnackbar } from 'components/ui/snackbar/helper';

function ShowcaseContactsCompanyIndex() {
  const [show, setShow] = useState(false);
  const [showcaseContacts, setShowcaseContacts] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const handleDataResponse = useCallback((data) => {
    setShow(true);
    if (Array.isArray(data) && data.length > 0) {
      setShowcaseContacts(data);
    } else {
      setShowcaseContacts([]);
    }
  }, [showcaseContacts]);

  useEffect(() => {
    fetchShowcaseContacts()
      .then(handleDataResponse)
      .catch(() => { /* noop - when the customization is not enabled, /showcase_contacts returns 401 */ });
  }, []);


  if (!show) return null;

  // handleContactAdded is a callback to be called after a contact has already been created on the backend
  // Errors and validation will be handled in the form component
  const handleContactAdded = (contact) => {
    setShowModal(false);
    setShowcaseContacts([...showcaseContacts, contact]);
    showSnackbar({ text: `Contact "${contact.firstName} ${contact.lastName}" added!`, variant: 'success' });
  };

  const handleDeleteContact = (contact) => {
    const { firstName, lastName, id } = contact;

    confirm(
      `Are you sure you want to delete contact "${firstName} ${lastName}?"`,
      {
        buttonLabel: 'Delete',
        buttonStyle: 'danger',
        title: 'Delete Contact?',
      }
    ).then(() => {
      deleteShowcaseContact(id).then(handleDataResponse).then(() => {
        showSnackbar({ text: `Contact "${firstName} ${lastName}" deleted!`, variant: 'danger' });
      });
    });
  };

  return (
    <>
      <div className="w-100">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5 className="fw-light">Showcase Contacts</h5>
          <Button variant="primary" onClick={() => setShowModal(true)}>
            + Add Showcase Contact
          </Button>
        </div>
        {showcaseContacts.length === 0 ? (
          <Card className="mt-3">
            <Card.Body className="text-muted">
              No showcase contacts found. Add a new contact to get started.
            </Card.Body>
          </Card>
        ) : (
          <div className="table-container">
            <table className="table table-responsive table-hover align-middle">
              <thead>
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Job Title</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {showcaseContacts.map(contact => (
                  <tr key={contact.id}>
                    <td></td>
                    <td>{contact.firstName} {contact.lastName}</td>
                    <td>{contact.email}</td>
                    <td>{contact.jobTitle}</td>
                    <td className="text-end">
                      <Button
                        aria-label="Delete contact"
                        className="text-destructive"
                        variant="link"
                        onClick={() => handleDeleteContact(contact)}
                      >
                        <FontAwesomeIcon className="text-destructive" icon={faTrash} />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <ShowcaseContactModal
        show={showModal}
        onAddContact={handleContactAdded}
        onClose={() => setShowModal(false)}
      />
    </>
  );
}

export default ShowcaseContactsCompanyIndex;
